import { Box } from "@mui/material";
import { EmailField, PhoneField } from "@src/appV2/lib";
import { type ReactElement } from "react";

import { AuthMethod } from "../types";

interface AuthFormFieldsProps {
  authMethod: AuthMethod;
  onMaxLengthAttempt: () => void;
}

export function AuthFormFields(props: AuthFormFieldsProps): ReactElement {
  const { authMethod, onMaxLengthAttempt } = props;

  return (
    <Box>
      {authMethod === AuthMethod.PHONE ? (
        <PhoneField name="phoneNumber" showLabel={false} onMaxLengthAttempt={onMaxLengthAttempt} />
      ) : (
        <EmailField name="email" showLabel={false} />
      )}
    </Box>
  );
}
